import * as React from "react";
import { Icon } from "../actions/Icon";
import { Timestamp } from "../display/Timestamp";

/**
 * A decision from a meeting: verified icon, sentence, source timestamp.
 */
export interface DecisionProps {
  text: React.ReactNode;
  time: string;
  active?: boolean;
  onTimeClick?: () => void;
  /** Inline timestamp after the text (mobile) */
  inline?: boolean;
  className?: string;
}

export function Decision({ text, time, active, onTimeClick, inline, className }: DecisionProps): JSX.Element {
  const ts = <Timestamp time={time} active={active} onClick={onTimeClick} />;
  return (
    <div className={["gk-decision", className].filter(Boolean).join(" ")}>
      <Icon name="seal-check" fill size={20} />
      <span className="gk-decision__text">
        {text}
        {inline && <> {ts}</>}
      </span>
      {!inline && ts}
    </div>
  );
}
